<template>
  <div class="card-item card-item-place">
    <icon-checkin
      v-if="checkinAt"
      class="icon checkin"
      v-ifield-b-tooltip="iconTooltipText.checkin"
    />
    <icon-place
      v-else
      class="icon"
      v-ifield-b-tooltip="iconTooltipText.place"
    />
    <span
      ref="truncTarget"
      class="text ellipsis"
      v-ifield-b-tooltip="tooltipOption"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
import { toRefs } from 'vue'
import IconPlace from '@/assets/ifield/ic_place.svg?component'
import IconCheckin from '@/assets/ifield/ic_checkin.svg?component'
import { useIsTruncated } from '@/composables/UseIsTruncated'
import { useUserStatusAdditionalItemPlace } from '@/composables/user/additionalItem'

export default {
  name: 'AppCardMemberItemPlace',
  components: {
    IconPlace,
    IconCheckin,
  },
  inheritAttrs: false,
  props: {
    /**
     * プレイス名
     */
    placeName: {
      type: String,
      default: null,
    },
    /**
     * チェックイン日時
     */
    checkinAt: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const { placeName } = toRefs(props)
    const { truncTarget, isTruncated } = useIsTruncated()
    const { text } = useUserStatusAdditionalItemPlace({ placeName })
    return { truncTarget, isTruncated, text }
  },
  computed: {
    /**
     * アイコン部ツールチップテキスト
     * @type {Object}
     */
    iconTooltipText: function () {
      return {
        checkin: `${this.$t('appCardMemberItemPlace.checkin')} : ${this.text}`,
        place: `${this.$t('appCardMemberItemPlace.place')} : ${this.text}`,
      }
    },
    /**
     * ツールチップオプション
     * @type {Object}
     */
    tooltipOption: function () {
      return {
        title: this.text,
        disabled: !this.isTruncated,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../assets/scss/parts/member/card-member-item';

.icon {
  &.checkin {
    padding: 2px;
    background-color: $entity-color-yellow;
    border-radius: 50%;
  }
}
</style>
